<template>
  <div class="slide-content">
    <div class="slide-content-1" @click="jumpXXQG">
      <img src="../../assets/img/home/xxqg.png" alt="">
    </div>
    <div class="slide-content-2">
      <div class="hover-img">
        <img src="../../assets/img/home/qrCode.png" alt="">
      </div>
      <img src="../../assets/img/home/gggzh.png" alt="">
    </div>
    <div class="slide-content-3">
      <a-back-top>
      <img src="../../assets/img/home/hddb.png" alt="">
      </a-back-top>
    </div>
    <div class="slide-content-4">
      <img src="../../assets/img/home/qrCode.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    jumpXXQG(){
      window.open('https://www.xuexi.cn/')
    }
  }
}
</script>

<style lang="scss">
  .slide-content{
    position: fixed;
    right:50px;
    top:500px;
    z-index: 10000;
    width:125px;
    .slide-content-1{
      img{
        width:126px;
        height:70px;
        cursor: pointer;
      }
    }
    .slide-content-2{
      margin:1.5px 0;
      img{
        width: 126px;
        height:auto;
      }
      .hover-img{
        display: none;}
    }

    .slide-content-2:hover{
      margin:1.5px 0;
      position: relative;
      img{
        width: 126px;
        height:auto;
      }
      .hover-img{
        display: block;
        position: absolute;
        top:-126px;
      }
    }




    .slide-content-3{
      margin:1.5px 0;

      img{
        width: 126px;
        height:auto;
      }
      .ant-back-top{
        position: relative;
        right:0;
        bottom:0
      }
    }
    .slide-content-4{
      margin:1.5px 0;
      width: 126px;
      height:126px;
      background: #eeeeee;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 104px;
        height:104px
      }
    }
  }
</style>